<template>
  <transition name="sidemenu-slide">
    <div v-show="showableSideMenu" class="side-menu__content side-menu">
      <div class="side-menu__header">
        <div
          v-show="isLoggedIn"
          class="side-menu__header__list--login registration"
        >
          <div class="side-menu-list__user-info">
            <a
              :href="linkUrl"
              @click="pushDataLayer({ event: 'click_menu__profile1' })"
            >
              <div class="side-menu-list__user">
                <AccountIconWh40 :image-url="iconImageUrl" />
                <div class="side-menu-list__nickname-aria">
                  <div
                    v-if="!hasProfile"
                    class="side-menu-list__profile-no-setting-text"
                  >
                    プロフィール未設定
                  </div>
                  <div class="side-menu-list__nickname">
                    {{ nickname }}
                  </div>
                </div>
              </div>
              <div
                v-if="!!profileDescription"
                class="side-menu-list__profile-description"
              >
                {{ profileDescription }}
              </div>
            </a>
            <a
              id="profile-guide-link"
              href="https://giftee.com/announcements/472"
              @click="pushDataLayer({ event: 'click_menu__profile_guide' })"
            >
              プロフィール活用方法を見る
            </a>
          </div>
          <ul class="search-list-group">
            <li class="search-list">
              <TextLinkList
                href="/mypage/gifts"
                text="使えるギフト"
                chevron-color="link"
                :bold="true"
                @click="pushDataLayer({ event: 'click_menu__gifts' })"
              />
            </li>
            <li class="search-list">
              <TextLinkList
                href="/mypage/received_logs"
                text="受け取りログ"
                chevron-color="link"
                :bold="true"
                @click="pushDataLayer({ event: 'click_menu__received_logs' })"
              />
            </li>
            <li class="search-list">
              <TextLinkList
                href="/mypage/order_histories"
                text="購入履歴"
                chevron-color="link"
                :bold="true"
                @click="pushDataLayer({ event: 'click_menu__order_histories' })"
              />
            </li>
            <li class="search-list">
              <TextLinkList
                href="/mypage/gift_codes"
                text="ギフトコード"
                chevron-color="link"
                :bold="true"
                @click="pushDataLayer({ event: 'click_menu__gift_codes' })"
              />
            </li>
            <li class="search-list">
              <TextLinkList
                :href="linkUrl"
                text="プロフィール・ほしいものリスト"
                chevron-color="link"
                :bold="true"
                @click="pushDataLayer({ event: 'click_menu__profile2' })"
              />
            </li>
            <li v-if="isLoggedIn" class="item-sku-bookmarks">
              <TextLinkList
                href="/mypage/item_sku_bookmarks"
                text="ブックマークしたギフト"
                chevron-color="link"
                :bold="true"
                @click="pushDataLayer({ event: 'click_menu__bkmk_list' })"
              />
            </li>
            <li class="follows">
              <TextLinkList
                href="/mypage/follows"
                text="フォローしている人"
                chevron-color="link"
                :bold="true"
                @click="pushDataLayer({ event: 'click_menu__follows' })"
              />
            </li>
          </ul>
        </div>
        <div v-show="!isLoggedIn" class="side-menu__header__list--logout">
          <a
            href="/barista/registrations/new"
            class="side-menu-list-with-icon"
            @click="
              pushDataLayer({ event: 'signup_click', button: 'sidemenu' })
            "
          >
            <div class="side-menu-list">
              <OutlinePerson class="side-menu-list__registration-icon" />
              <span class="side-menu-list__text--orange">新規会員登録</span>
            </div>
          </a>
          <a
            href="/barista/sessions/new"
            class="side-menu-list-with-icon"
            @click="
              pushDataLayer({ event: 'signin_click', button: 'sidemenu' })
            "
          >
            <div class="side-menu-list">
              <OutlineLogin class="side-menu-list__login-icon" />
              <span class="side-menu-list__text">ログイン</span>
            </div>
          </a>
        </div>
      </div>
      <ul class="search-list-group">
        <li class="search-list-title">ギフトを贈る</li>
        <li class="search-list">
          <TextLinkListExpand
            text="ブランドから探す"
            chevron-color="link"
            :bold="true"
          >
            <div class="side-menu-list--two-column">
              <TextLinkList
                class="side-menu-list__text-link-list"
                href="/brands"
                text="すべてのブランド"
                chevron-color="link"
                background-color="gray-3"
                :bold="true"
                :thin="true"
                @click="pushDataLayer({ event: 'click_menu__brand_list' })"
              />
              <TextLinkList
                v-for="(brand, index) in brands"
                :key="index"
                class="side-menu-list__text-link-list"
                :href="`/brands/${brand.id}`"
                :text="brand.name"
                chevron-color="link"
                background-color="gray-3"
                :bold="true"
                :thin="true"
                @click="
                  pushDataLayer({
                    event: 'click_menu__brand',
                    brand_id: brand.id
                  })
                "
              />
            </div>
          </TextLinkListExpand>
        </li>
        <li class="search-list">
          <TextLinkListExpand
            text="カテゴリから探す"
            chevron-color="link"
            :bold="true"
          >
            <div class="side-menu-list--two-column">
              <TextLinkList
                v-for="(category, index) in categories"
                :key="index"
                class="side-menu-list__text-link-list"
                :href="`/items?category_id=${category.id}`"
                :text="category.name"
                chevron-color="link"
                background-color="gray-3"
                :bold="true"
                :thin="true"
                @click="
                  pushDataLayer({
                    event: 'click_menu__category',
                    category_id: category.id
                  })
                "
              />
            </div>
          </TextLinkListExpand>
        </li>
        <li class="search-list">
          <TextLinkListExpand
            text="シーンから探す"
            chevron-color="link"
            :bold="true"
          >
            <div class="side-menu-list--two-column">
              <TextLinkList
                class="side-menu-list__text-link-list"
                href="/scenes"
                text="すべてのシーン"
                chevron-color="link"
                background-color="gray-3"
                :bold="true"
                :thin="true"
                @click="pushDataLayer({ event: 'click_menu__scene_list' })"
              />
              <TextLinkList
                v-for="(scene, index) in scenes"
                :key="index"
                class="side-menu-list__text-link-list"
                :href="`/items?scene_id=${scene.id}`"
                :text="scene.name"
                chevron-color="link"
                background-color="gray-3"
                :bold="true"
                :thin="true"
                @click="
                  pushDataLayer({
                    event: 'click_menu__scene',
                    scene_id: scene.id
                  })
                "
              />
            </div>
          </TextLinkListExpand>
        </li>
        <li class="search-list">
          <TextLinkListExpand
            text="受け取り方法から探す"
            chevron-color="link"
            :bold="true"
          >
            <div class="side-menu-list--one-column">
              <TextLinkList
                v-for="(receivingKind, index) in receivingKinds"
                :key="index"
                class="side-menu-list__text-link-list"
                :href="`/items?item_receiving_kinds%5B%5D=${receivingKind.id}`"
                :text="receivingKind.name"
                chevron-color="link"
                background-color="gray-3"
                :bold="true"
                :thin="true"
                @click="
                  pushDataLayer({
                    event: 'click_menu__item_receiving_kind',
                    item_receiving_kind_id: receivingKind.id
                  })
                "
              />
            </div>
          </TextLinkListExpand>
        </li>
        <li class="search-list">
          <TextLinkListExpand
            text="カードデザインから探す"
            chevron-color="link"
            :bold="true"
          >
            <div class="side-menu-list--two-column">
              <TextLinkList
                class="side-menu-list__text-link-list"
                href="/card_designs"
                text="すべてのデザイン"
                chevron-color="link"
                background-color="gray-3"
                :bold="true"
                :thin="true"
                @click="
                  pushDataLayer({
                    event: 'click_menu__card_design_category_all'
                  })
                "
              />
              <TextLinkList
                v-for="(cardDesignCategory, index) in cardDesignCategories"
                :key="index"
                class="side-menu-list__text-link-list"
                :href="`/card_designs?category_id=${cardDesignCategory.id}`"
                :text="cardDesignCategory.name"
                chevron-color="link"
                background-color="gray-3"
                :bold="true"
                :thin="true"
                @click="
                  pushDataLayer({
                    event: 'click_menu__card_design_category',
                    card_design_category_id: cardDesignCategory.id
                  })
                "
              />
            </div>
          </TextLinkListExpand>
        </li>
        <li class="search-list">
          <TextLinkList
            href="/announcements/specials"
            text="特集・キャンペーンから探す"
            chevron-color="link"
            :bold="true"
            @click="pushDataLayer({ event: 'click_menu__announcement_list' })"
          />
        </li>
        <li class="search-list">
          <TextLinkList
            href="/announcements/giftee_columns"
            text="ギフトコラムから探す"
            chevron-color="link"
            :bold="true"
            @click="pushDataLayer({ event: 'click_menu__column_list' })"
          />
        </li>
        <li class="search-list">
          <TextLinkList
            href="/items/recent_view"
            text="最近チェックしたギフトから探す"
            chevron-color="link"
            :bold="true"
            @click="pushDataLayer({ event: 'click_menu__view_history_list' })"
          />
        </li>
        <li class="search-list">
          <TextLinkListExpand
            text="まとめてオーダーを申し込む"
            chevron-color="link"
            :bold="true"
          >
            <div class="side-menu-list--one-column">
              <div class="side-menu-list__icon-link">
                <span class="side-menu-list__icon--bulk-order-online"></span>
                <TextLinkList
                  class="side-menu-list__text-link-list--no-padding-left"
                  :href="BULK_ORDER_LP_URL"
                  text="オンラインで贈る"
                  chevron-color="link"
                  background-color="gray-3"
                  :bold="true"
                  :thin="true"
                  @click="pushDataLayer({ event: 'click_menu__bulk_url_lp' })"
                />
              </div>
            </div>
            <div class="side-menu-list--one-column">
              <div class="side-menu-list__icon-link">
                <span class="side-menu-list__icon--bulk-order-phy"></span>
                <TextLinkList
                  class="side-menu-list__text-link-list--no-padding-left"
                  :href="FULFILLMENT_BULK_ORDER_LP_URL"
                  text="手渡しカードで贈る"
                  chevron-color="link"
                  background-color="gray-3"
                  :bold="true"
                  :thin="true"
                  @click="pushDataLayer({ event: 'click_menu__bulk_phys_lp' })"
                />
              </div>
            </div>
          </TextLinkListExpand>
        </li>
      </ul>
      <ul class="search-list-group">
        <li class="search-list-title">gifteeについて</li>
        <li class="search-list">
          <TextLinkList
            href="/about"
            text="gifteeとは"
            chevron-color="link"
            :bold="true"
            @click="pushDataLayer({ event: 'click_menu__about' })"
          />
        </li>
        <li class="search-list">
          <TextLinkList
            href="https://guide.giftee.com/"
            text="ご利用ガイド"
            chevron-color="link"
            :bold="true"
            @click="pushDataLayer({ event: 'click_menu__guide' })"
          />
        </li>
        <li class="search-list">
          <TextLinkList
            href="https://guide.giftee.com/category/faq/"
            text="よくあるご質問"
            chevron-color="link"
            :bold="true"
            @click="pushDataLayer({ event: 'click_menu__faq' })"
          />
        </li>
      </ul>
      <ul v-show="isLoggedIn" class="search-list-group">
        <li class="search-list-title">アカウント管理</li>
        <li class="search-list">
          <TextLinkList
            href="/mypage/settings"
            text="ログイン設定"
            chevron-color="link"
            :bold="true"
            @click="pushDataLayer({ event: 'click_menu__login_settings' })"
          />
        </li>
        <li class="search-list">
          <TextLinkList
            href="/mypage/settings/notifications/edit"
            text="受信設定"
            chevron-color="link"
            :bold="true"
            @click="
              pushDataLayer({ event: 'click_menu__notification_settings' })
            "
          />
        </li>
        <li class="search-list">
          <TextLinkList
            href="/logout"
            text="ログアウト"
            chevron-color="link"
            :bold="true"
            @click="pushDataLayer({ event: 'click_menu__logout' })"
          />
        </li>
        <li class="search-list">
          <TextLinkList
            href="/accounts/withdraw"
            text="退会"
            chevron-color="link"
            :bold="true"
            @click="pushDataLayer({ event: 'click_menu__withdraw' })"
          />
        </li>
      </ul>
      <ul class="search-list-group">
        <li class="giftee-for-business-menu">
          <a
            href="https://giftee.biz/?utm_source=com&utm_medium=referral&utm_campaign=com_header"
            target="_blank"
            rel="noopener"
          >
          </a>
        </li>
      </ul>
    </div>
  </transition>
</template>
<script>
import AccountIconWh40 from '../../atoms/account_icons/AccountIconWh40.vue'
import OutlinePerson from '../../atoms/svg_icons/OutlinePerson.vue'
import OutlineLogin from '../../atoms/svg_icons/OutlineLogin.vue'
import TextLinkList from '../../molecules/text_link_lists/TextLinkList.vue'
import TextLinkListExpand from '../../molecules/text_link_lists/TextLinkListExpand.vue'
import {
  BULK_ORDER_LP_URL,
  FULFILLMENT_BULK_ORDER_LP_URL
} from '../../../constants/externalLinkConstants'
import axios from 'axios'

export default {
  components: {
    AccountIconWh40,
    OutlinePerson,
    OutlineLogin,
    TextLinkList,
    TextLinkListExpand
  },
  props: {
    showableSideMenu: {
      type: Boolean,
      required: true
    },
    isLoggedIn: {
      type: Boolean,
      required: true
    },
    linkUrl: {
      type: String,
      required: true
    },
    iconImageUrl: {
      type: String,
      required: true
    },
    nickname: {
      type: String,
      required: true
    },
    hasProfile: {
      type: Boolean,
      required: true
    },
    profileDescription: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      BULK_ORDER_LP_URL,
      FULFILLMENT_BULK_ORDER_LP_URL,
      brands: [],
      categories: [],
      scenes: [],
      receivingKinds: [],
      cardDesignCategories: []
    }
  },
  mounted() {
    this.getBrands()
    this.getItemCategories()
    this.getScenes()
    this.getReceivingKinds()
    this.getCardDesignCategories()
  },
  methods: {
    pushDataLayer(dataLayerValue) {
      dataLayer.push(dataLayerValue)
    },
    async getBrands() {
      try {
        const res = await axios.get('/api/v1/pickup/brands?limit=15')
        this.brands = res.data.data.map(brand => {
          return {
            id: brand.attributes.id.toString(),
            name: brand.attributes.name
          }
        })
      } catch (error) {
        this.hundleApiError(error)
      }
    },
    async getItemCategories() {
      try {
        const res = await axios.get('/api/v1/pickup/item_categories')
        this.categories = res.data.data.map(category => {
          return {
            id: category.attributes.id.toString(),
            name: category.attributes.name
          }
        })
      } catch (error) {
        this.hundleApiError(error)
      }
    },
    async getScenes() {
      try {
        const res = await axios.get('/api/v1/pickup/scenes')
        this.scenes = res.data.data.map(scene => {
          return {
            id: scene.attributes.id.toString(),
            name: scene.attributes.name
          }
        })
      } catch (error) {
        this.hundleApiError(error)
      }
    },
    async getReceivingKinds() {
      try {
        const res = await axios.get('/api/v1/pickup/item_receiving_kinds')
        this.receivingKinds = res.data.data.map(receiving_kind => {
          return {
            id: receiving_kind.attributes.id.toString(),
            name: receiving_kind.attributes.displayName
          }
        })
      } catch (error) {
        this.hundleApiError(error)
      }
    },
    async getCardDesignCategories() {
      try {
        const res = await axios.get('/api/v1/pickup/card_design_categories')
        this.cardDesignCategories = res.data.data.map(card_design_category => {
          return {
            id: card_design_category.attributes.id.toString(),
            name: card_design_category.attributes.name
          }
        })
      } catch (error) {
        this.hundleApiError(error)
      }
    }
  },
  hundleApiError(error) {
    this.errorMessage =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
  }
}
</script>
<style lang="scss" scoped>
.side-menu {
  &__header {
    margin-bottom: 8px;
  }
}

%side-menu-list__text {
  margin: auto 0;
  padding-left: 12px;
  font-size: 16px;
  font-weight: bold;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  flex: 1;
  text-align: left;
}

%side-menu-list__icon {
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

%side-menu-list__text-link-list {
  flex: 1;
  min-width: 0;
}

.side-menu-list-with-icon {
  @extend %hover-common;
  font-size: 1.4rem;
  line-height: 1.6;
  color: $black;
  cursor: pointer;
  text-decoration: none;
  border-bottom: 1px $gray-2 solid;
  display: block;
  width: 100%;
  box-sizing: border-box;
  background-color: $white;
  padding: 0;
  margin: 0;

  background-color: $white;

  &:last-child {
    border-bottom: 0;
  }

  .side-menu-list {
    padding: 16px;
    margin: 0;
    display: flex;
    align-items: center;

    &__registration-icon,
    &__login-icon {
      width: 20px;
    }

    &__text {
      @extend %side-menu-list__text;

      &--orange {
        @extend %side-menu-list__text;
        color: $primary;
      }
    }
  }
}

.search-list-title {
  @extend %caption-bold;
  padding: 12px;
  background-color: $white;
}

.search-list {
  display: block;

  &:hover {
    opacity: 1;
  }
}

.search-list-group {
  margin-bottom: 8px;
}

.side-menu-list {
  &__user-info {
    padding: 12px;
    background-color: $white;
    text-align: left;
    margin-bottom: 8px;

    a {
      display: block;
      @extend %hover-common;
    }
  }

  &__user {
    margin: 0;
    display: flex;
    align-items: center;
  }

  &__nickname-aria {
    margin-left: 8px;
  }

  &__profile-no-setting-text {
    @extend %minimal;
    color: $black;
    margin-bottom: 4px;
  }

  &__nickname {
    @extend %body-bold;
  }

  &__profile-description {
    @extend %caption;
    color: black;
    margin-top: 8px;
    text-align: left;
    height: 38px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }

  &--one-column {
    display: grid;
    grid-template-columns: repeat(1, 100%);
    background-color: $gray-3;
    border-bottom: 1px solid $gray-2;

    .side-menu-list__text-link-list {
      &:not(:last-child) {
        border-bottom: 1px solid $gray-2;
      }
    }
  }

  &__icon-link {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-left: 12px;
    background-color: $gray-3;

    .side-menu-list__text-link-list {
      @extend %side-menu-list__text-link-list;

      &--no-padding-left {
        @extend %side-menu-list__text-link-list;

        :deep(.text-link-list__link) {
          padding-left: 0;
        }
      }
    }
  }

  &__icon {
    &--bulk-order-online {
      @extend %side-menu-list__icon;
      background-image: url('../../../../../images/bulk-order-online.svg');
    }

    &--bulk-order-phy {
      @extend %side-menu-list__icon;
      background-image: url('../../../../../images/bulk-order-phy.svg');
    }
  }

  &--two-column {
    display: grid;
    grid-template-columns: repeat(2, 50%);
    background-color: $gray-3;
    border-bottom: 1px solid $gray-2;

    .side-menu-list__text-link-list {
      border-bottom: 1px solid $gray-2;

      &:nth-child(2n + 1) {
        // リンクの間にborderを引く
        border-right: 1px solid $gray-2;
      }

      &:nth-last-child(1),
      &:nth-last-child(2):nth-child(2n + 1) {
        // 親でborderを引いているのと重複するため、一番下の行は下にborderを引かない。
        // 最後から2番目のリンクは奇数番目（左側）にある場合に一番下の行になるので、nth-child(2n + 1)で指定する。
        border-bottom: none;
      }
    }
  }
}

#profile-guide-link {
  @extend %caption;
  color: $link;
  margin-top: 8px;
  text-align: left;
}

.giftee-for-business-menu {
  padding: 16px 12px;
  background-color: white;

  a {
    @extend %hover-common;
    background-image: url('../../../../../images/giftee_for_business/01_banner_menu_PC.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    display: block;
    height: 56px;

    @media all and (max-width: ($base-contents-width - 1)) {
      background-image: url('../../../../../images/giftee_for_business/02_banner_menu_SP.png');
    }
  }
}
</style>
